// extracted by mini-css-extract-plugin
export default {"dialog":"BeforePurchaseModal__dialog--U53jw","content":"BeforePurchaseModal__content--RTEDm"};